import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28fc7816"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "align-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-font-size mt--10 mb--15" }, "Спасибо!", -1))
const _hoisted_3 = { class: "m-font-size" }
const _hoisted_4 = { class: "medium" }
const _hoisted_5 = { class: "no-wrap" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mt--10 mb--15" }, "Закажите бесплатный звонок", -1))
const _hoisted_8 = { class: "call-order__bottom-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "second-color xs-font-size align-center call-order__info" }, [
    /*#__PURE__*/_createTextVNode("Нажимая кнопку, вы даете свое согласие на обработку "),
    /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "персональных данных")
  ])
], -1))
const _hoisted_10 = { class: "center" }

import { Ref, ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { ErrorsType } from '@/types';
import { vMaska } from 'maska';
import { useAppStore } from '@/store/modules/app';
import { FreeCallDataType } from '@/api/common/types';

type FormDataType = {
  phone: string | undefined;
  text: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CallOrderCard',
  props: {
    cardId: {}
  },
  setup(__props: any) {

const props = __props;
const formData: Ref<FormDataType> = ref({
  phone: undefined,
  text: undefined,
});
const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  phone: { required },
  text: {},
};
const v$ = useVuelidate<FormDataType>(rules, formData);

const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};
const isLoading = ref(false);
const isCallOrdered = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }

  if (formData.value.phone) {
    isLoading.value = true;

    const preparedData: FreeCallDataType = {
      ...formData.value,
      text: formData.value.text,
      phone: formData.value.phone?.replace(/[^\d]/g, ''),
      offer_card_id: props.cardId,
    };

    try {
      const res = await useAppStore().orderFreeCall(preparedData);

      if (res) {
        isCallOrdered.value = true;
      }
    } catch (error) {
      errors.value = validationErrorsByRequest(error);
    } finally {
      isLoading.value = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: "call-order",
    "full-width-mobile": "",
    "without-mobile-shadow": ""
  }, {
    default: _withCtx(() => [
      (isCallOrdered.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(" Ваша заявка отправлена продавцу и "),
              _createElementVNode("span", _hoisted_4, [
                _createTextVNode("в ближайшее время он свяжется с вами по телефону "),
                _createElementVNode("span", _hoisted_5, "+7 " + _toDisplayString(formData.value.phone), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_base_form, { class: "grid--1 gap--15" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_base_input, {
                  modelValue: formData.value.phone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.phone) = $event)),
                  error: errors.value.phone,
                  invalid: !!errors.value.phone,
                  "data-maska": "(###)###-##-##",
                  height: "34",
                  label: "Телефон",
                  placeholder: "(999)000-99-99",
                  prefix: "+7 ",
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('phone'))),
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.phone)),
                  onInput: _unref(v$).phone.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"]), [
                  [_unref(vMaska)]
                ]),
                _createVNode(_component_base_textarea, {
                  modelValue: formData.value.text,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.text) = $event)),
                  error: errors.value.text,
                  invalid: !!errors.value.text,
                  styleType: 'light',
                  height: "34",
                  label: "Уточните запрос, если хотите",
                  textarea: "",
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('text'))),
                  onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.text)),
                  onInput: _unref(v$).text.$touch
                }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_base_button, {
                      height: _unref(useAppStore)().getWindowWidth() < 600 ? 34 : 46,
                      loading: isLoading.value,
                      text: "Заказать звонок",
                      onClick: formSubmit
                    }, null, 8, ["height", "loading"])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})